import { VSheet } from 'vuetify/lib/components/VSheet';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSheet,
    { staticClass: "d-flex flex-column" },
    [
      _vm.selectedProducts
        ? _c("span", { staticClass: "text-caption" }, [
            _vm._v(_vm._s(_vm.label)),
          ])
        : _vm._e(),
      _c(
        "treeselect",
        _vm._b(
          {
            key: _vm.ts,
            attrs: {
              multiple: _vm.multiple,
              options: _vm.productTree,
              "disable-branch-nodes": true,
              "show-count": true,
              placeholder: _vm.label,
              required: _vm.required,
            },
            on: { input: _vm.onUpdate },
            model: {
              value: _vm.selectedProducts,
              callback: function ($$v) {
                _vm.selectedProducts = $$v
              },
              expression: "selectedProducts",
            },
          },
          "treeselect",
          _vm.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }